import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { cloneDeep } from 'lodash';
import { useMemo } from 'react';

import LandingPageMembershipTabs from '@/app/components/LandingPage/LandingPageMembershipTabs';
import japaneseMembershipTabsOverrides from '@/app/components/LandingPage/LandingPageMembershipTabs/_data/japaneseLandingPageMembershipTabDataOverrides';
import getLandingPageMembershipTabData from '@/app/components/LandingPage/LandingPageMembershipTabs/_utils/getLandingPageMembershipTabData';
import useJapaneseRegionalSite from '@/app/experiments/useJapaneseRegionalSite';
import useAuroraRollout from '@/app/hooks/useAuroraRollout';
import useTrustedAdvisorRollout from '@/app/hooks/useTrustedAdvisorRollout';

import PopMembershipContent from './PopMembershipContent';

const PopMembership = () => {
  const isJapaneseRegionalSite = useJapaneseRegionalSite();
  // TODO: GROW-2891 Clean up aurora rollout
  const isAuroraEnabled = useAuroraRollout();
  // TODO: GROW-2946 Clean up trusted advisor rollout
  const isTrustedAdvisorEnabled = useTrustedAdvisorRollout();

  const tabData = useMemo(() => {
    const baseTabData = getLandingPageMembershipTabData(
      isAuroraEnabled,
      isTrustedAdvisorEnabled,
    );
    return isJapaneseRegionalSite
      ? cloneDeep(baseTabData).map((tab) => {
          return {
            ...tab,
            tabPanel: {
              ...tab.tabPanel,
              ...japaneseMembershipTabsOverrides[tab.id]?.tabPanel,
            },
          };
        })
      : baseTabData;
  }, [isJapaneseRegionalSite, isAuroraEnabled, isTrustedAdvisorEnabled]);

  return (
    <section className="pt-20 pb-16" data-cy="pop-membership-section">
      <LayoutGrid rowGap={0}>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <PopMembershipContent />
        </GridItem>
      </LayoutGrid>
      <LandingPageMembershipTabs tabsData={tabData} />
    </section>
  );
};

export default PopMembership;
